module.exports = __webpack_public_path__ + "static/1-81a13d33d6070206f60a4faa304ae808.jpg";